var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppCard',{attrs:{"item":_vm.item,"source":"search"},scopedSlots:_vm._u([{key:"actionSlot",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }